export const loadPluralMapping = {
  '=0': 'No Loads',
  '=1': '1 Load',
  other: '# Loads',
};
